import {
    countriesList,
    type SupportedCountry,
} from '@archipro-website/localisation';

export interface HomeCopy {
    professionalsDescription: string;
    magazineDescription: string;
}

/**
 * Market-specific copy for the logged-out homepage. The possessive prefix
 * ("New Zealand's" / "Australia's" / "America's") comes from the localisation
 * country name so the wording follows the visitor's market.
 */
export const getHomeCopy = (country: SupportedCountry): HomeCopy => {
    const possessive = `${countriesList[country].name}’s`;

    return {
        professionalsDescription: `We’ve curated ${possessive} leading professionals so you can find the best fit for your project. Browse their work, discover their services and enquire directly from ArchiPro.`,
        magazineDescription: `${possessive} most exciting architectural projects, products and professionals featured weekly in an interactive experience`,
    };
};
